module.exports = __webpack_public_path__ + "static/media/large_baloon2.1590528e.svg";